module.exports = __webpack_public_path__ + "static/media/PreOrder.b9be8b19.svg";